<template>
    <div class="bg-login-fuzzy">
        <x-container fluid justify-center align-center>
            <x-flex xs6 sm6 offset-xs4 offset-sm3 fill-height align-center>
                <x-card fill-height fill-width class="elevation-12 pa-5 mt-5">
                    <x-card-title><h4>Unauthorised</h4></x-card-title>
                    <x-card-text>
                        <p>
                            Sorry you do not have access to this page.
                        </p>
                    </x-card-text>
                    <x-card-actions>
                        <x-btn v-if="showDashboardLink" @click="goToDashboard" color="primary">Back to Dashboard</x-btn>
                    </x-card-actions>
                </x-card>
            </x-flex>
        </x-container>
    </div>
</template>

<script>
    export default {
        name: "UnauthorisedPage",
        computed: {
            showDashboardLink() {
                return this.$root.user.hasOwnProperty('id');
            }
        },
        methods: {
            goToDashboard() {
                if (['insurer', 'captive_insurer'].includes(this.$root.user.company.company_type)) {
                    this.$router.push({ name: 'insurer-dashboard'});
                } else {
                    this.$router.push({ name: 'broker-dashboard'});
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    p {
        font-size: 16px;
        line-height: 24px;
    }

    .bg-login-fuzzy {
        position:absolute;
        width:100%;
        height:100%;
        background-image: url('/assets/img/background.jpg');
        background-size: cover;
        background-position: center center;
        overflow-y: auto;
    }

    .fade-in {
        animation: fade-in 1s;
    }
</style>
